import { getCampaignsListRequest, ReportUrl, formatDate } from "@common";
import { AppState, tryLoadCampaignSpentBudget } from "@store";
import { FetchingState } from "rd-redux-http";
import { LocationChangeAction, replace } from "react-router-redux";
import { put, select } from "redux-saga/effects";
import { reportCampaignListSelector } from "../selector";

export function* loadCampaignList(a: LocationChangeAction) {
    const appState: AppState = yield select();
    const reportPageMatch = ReportUrl.match(a.payload, true);
    const clientId = reportPageMatch.isMatched && reportPageMatch.params.clientId;

    if (
        !FetchingState.isSuccess(appState.campaignList.campaigns) ||
        appState.campaignList.campaigns.params.clientId !== clientId
    ) {
        try {
            yield* getCampaignsListRequest.saga({ clientId, _q: new Date().getTime() });
        } catch (e) {
            console.error(e);
            return;
        }
    }

    const urlMatch = ReportUrl.match(a.payload, true);

    if (urlMatch.isMatched) {
        const appStateWithCampaignList: AppState = yield select();
        const campaignList = reportCampaignListSelector(appStateWithCampaignList);
        const selectedCampaign = campaignList && campaignList.find(c => c.campaignId === urlMatch.params.campaignId);

        if ((!urlMatch.query || !urlMatch.query.fromDate || !urlMatch.query.toDate) && selectedCampaign) {
            const query = {
                fromDate: formatDate(selectedCampaign.startDate),
                toDate: formatDate(selectedCampaign.endDate)
            };

            yield put(
                replace(
                    ReportUrl.format(
                        {
                            ...urlMatch.params
                        },
                        { ...query }
                    )
                )
            );
        }

        if (
            !urlMatch.params.campaignId ||
            !campaignList.some(i => i.campaignId.toLowerCase() === (urlMatch.params.campaignId || "").toLowerCase())
        ) {
            if (campaignList.length) {
                yield put(
                    replace(
                        ReportUrl.format(
                            {
                                ...urlMatch.params,
                                campaignId: campaignList[0].campaignId
                            },
                            {}
                        )
                    )
                );
            }
        } else {
            yield* tryLoadCampaignSpentBudget(urlMatch.params.campaignId);
        }
    }
}
